import {teamMemberPhoto} from '../../../../../../assets/symbols/images/teamMemberPhoto';
import {createLecturer, updateLecturer} from '../../../../../../redux/timetable/timetableActions';
import {getEid} from '../../../../../../redux/event/eventActions';
import {uploadFile} from '../../../../../../redux/user/userActions';
import {isBase64Url} from '../../../../../../functions/isBase64Url';
import {TLecturer} from '../../../../../../redux/timetable/timetable.type';
import {Values} from './types';

export const submitLecturer = async (
    values: Values,
    close: () => void,
    onAdd?: (lecturer: TLecturer) => void,
    lid?: number,
) => {
    let image: string | null = null;
    if(values.image && values.image !== teamMemberPhoto) {
        image = isBase64Url(values.image)
            ? await uploadFile(values.image, '', 'lecturer', getEid())
            : values.image;
    }

    const payload: Omit<TLecturer, 'lid'> = {
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        email: values.email.trim() || null,
        phone: values.phone.trim() || null,
        image,
        about: values.about.trim() || null,
        link: values.link.trim() || null,
        liveLink: values.liveLink.trim() || null,
    };
    // On failure (e.g. duplicate phone) the action returns falsy and the
    // request layer already shows the server message — keep the popup open.
    if(lid) {
        const updated = await updateLecturer(lid, payload);
        if(updated) close();
        return;
    }
    const created = await createLecturer(payload);
    if(created) {
        onAdd?.(created);
        close();
    }
};
